module.exports = __webpack_public_path__ + "img/strawberry-cake.cf66c275.jpg";